@if (mode() === 'input-inventory') {
  <edit-inventory-supply (back)="onBack()" (save)="onSaveInventory(null)"></edit-inventory-supply>
} @else if (mode() === 'select-inventories') {
  <inventory-supplies (back)="onBack()" (save)="onSaveInventory($event)"></inventory-supplies>
} @else {
  <box size="lg">
    <app-header [title]="'ship_interface.monthly_rob_report' | transloco" [hasCloseButton]="true" (close)="_matDialog.closeAll()" [hasBottomBorder]="true" />
    <app-body [noPadding]="mode() === 'details'">
      @if (mode() === 'details') {
        <section class="border-b border-b-slate-300 py-6">
          <subtitle-block
            [title]="title"
            [subtitle]="subtitle"
            [hasPadding]="false"
            customClass="px-9 py-3"
            [subtitleFontClass]="'italic text-base font-normal text-accent'">
            <div action class="ml-2 flex w-full justify-end">
              @let data = detailReport()?.status_id | sealFindByKey: 'id' : statuses;
              <app-status-badge [label]="data?.name" [type]="data?.type" />
            </div>
          </subtitle-block>
          <grid customClass="grid-cols-[1fr_1fr_2fr]">
            <textbox
              class="w-full"
              [label]="'ship_interface.report_year' | transloco"
              [required]="true"
              [showIndicator]="true"
              [control]="form.get('year')"
              [placeholder]="'ship_interface.year' | transloco">
            </textbox>
            <dropdown
              class="w-full"
              [control]="form.get('month')"
              [label]="'ship_interface.report_month' | transloco"
              [required]="true"
              selectType="value"
              [options]="months"
              [placeholder]="'ship_interface.select_month' | transloco">
            </dropdown>
            <textbox
              [control]="form.get('remarks')"
              class="w-full"
              [label]="'ship_interface.remarks' | transloco"
              [placeholder]="'ship_interface.input_remarks_if_any' | transloco">
            </textbox>
          </grid>
        </section>
        <section class="py-6">
          <subtitle-block
            [hasPadding]="true"
            [title]="'ship_interface.inventory_item_details' | transloco"
            [hasAddNew]="true"
            (addNew)="onEditInventory(null)"></subtitle-block>
          <div class="px-9">
            <div class="grid-inventory bg-default mt-3 grid items-center gap-x-4 rounded-t-2xl border-b px-8 py-3">
              <div class="grid-inventory-header truncate">{{ 'ship_interface.inventory_item' | transloco }}</div>
              <div class="grid-inventory-header truncate">{{ 'ship_interface.description' | transloco }}</div>
              <div class="grid-inventory-header truncate">{{ 'ship_interface.rob' | transloco }}</div>
            </div>

            @if (!isEmpty(details.controls)) {
              <form>
                <div>
                  @for (detail of details?.controls; track trackById(i, detail); let i = $index; let last = $last) {
                    <div class="hover:cursor-pointer">
                      <div class="grid-inventory grid items-center gap-x-6 px-6" [ngClass]="{ 'border-b-[1.2px] border-b-gray-300': !last }">
                        <div>
                          <autofill
                            [control]="detail?.get('inventory_item_id')"
                            [inputClass]="'text-base'"
                            [noBorder]="true"
                            [apiEndpoint]="VesselReportApi.inventoryItems"
                            [options]="inventories()"
                            selectType="id"
                            displayName="name"
                            [hasSearchIcon]="true"
                            [placeholder]="'ship_interface.select_inventory_item' | transloco"
                            searchIcon="heroicons_outline:magnifying-glass"
                            [searchTooltip]="'ship_interface.select_inventory_item' | transloco"
                            (clickSearch)="onInventories(detail)">
                          </autofill>
                        </div>
                        <div class="truncate font-bold">
                          <textbox
                            [placeholder]="'ship_interface.enter_description_if_any' | transloco"
                            [control]="detail?.get('description')"
                            [noBorder]="true">
                          </textbox>
                        </div>
                        <div class="flex items-center">
                          <textbox class="flex flex-grow" [control]="detail?.get('value')" [placeholder]="'0.00'" [decimal]="2" type="number" [noBorder]="true">
                          </textbox>
                          <div class="w-fit truncate font-normal text-slate-400">{{ detail?.get('inventory_item_unit')?.value || '-' }}</div>
                        </div>
                        <button mat-icon-button (click)="$event.stopPropagation(); $event.preventDefault(); onDeleteInventory(i, detail?.get('id')?.value)">
                          <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              </form>
            }
          </div>
        </section>
      } @else {
        <subtitle-block
          [title]="title"
          [subtitle]="subtitle"
          [hasPadding]="false"
          customClass="px-9 py-3"
          [subtitleFontClass]="'italic text-base font-normal text-accent'">
          <div action class="ml-2 flex w-full justify-end">
            @let data = detailReport()?.status_id | sealFindByKey: 'id' : statuses;
            <app-status-badge [label]="data?.name" [type]="data?.type" />
          </div>
        </subtitle-block>
        <div class="px-9">
          <div
            class="grid-edit mt-4 grid items-center gap-x-4 rounded-t-2xl border-b border-b-accent px-6 py-3"
            [ngClass]="detailReport().status_id === 3 ? 'grid-edit-submit' : 'grid-edit'">
            @if (detailReport().status_id !== 3) {
              <div></div>
            }
            <div class="grid-edit-header truncate">
              <p>{{ 'ship_interface.inventory_item_description' | transloco }}</p>
            </div>
            <div class="grid-edit-header truncate">{{ 'ship_interface.month_end_rob' | transloco }}</div>
            <div class="grid-edit-header truncate"></div>
            @if (detailReport().status_id !== 3) {
              <div></div>
            }
          </div>
          @if (!isEmpty(detailReport()?.details)) {
            <div cdkDropList (cdkDropListDropped)="drop($event)">
              @for (detail of detailReport()?.details; track trackById(i, detail); let i = $index; let last = $last) {
                <div [ngClass]="{ 'pointer-events-none': detailReport()?.status_id === 3, 'hover:cursor-pointer': detailReport()?.status_id !== 3 }">
                  <div
                    cdkDrag
                    class="grid items-center gap-x-4 px-6 py-3"
                    [ngClass]="{
                      'grid-edit-submit': detailReport().status_id === 3,
                      'grid-edit': detailReport().status_id !== 3,
                      'border-b-[1.2px] border-b-gray-300': !last
                    }"
                    (click)="onEditInventory(detail)">
                    @if (detailReport().status_id !== 3) {
                      <div
                        cdkDragHandle
                        class="z-99999 mr-2 flex cursor-pointer items-center justify-center"
                        [ngClass]="{ hidden: detailReport()?.status_id === 3 }">
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                      </div>
                    }
                    <div class="truncate">
                      <p class="font-medium">
                        {{ detail?.inventory_item_name || '-' }}
                      </p>
                      <p class="font-normal italic">
                        {{ detail?.description || '-' }}
                      </p>
                    </div>
                    <div class="flex items-center">
                      <div class="flex-grow truncate font-semibold">
                        {{ detail?.value ? (detail?.value | round: 2) : '-' }}
                      </div>
                      <div class="truncate text-slate-400">
                        {{ detail?.inventory_item_unit || '-' }}
                      </div>
                    </div>
                    <div>
                      @if (detailReport().status_id !== 3) {
                        <button mat-icon-button (click)="$event.stopPropagation(); onDeleteInventory(1, detail.id)">
                          <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                        </button>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </app-body>
    <app-footer
      [hasTopBorder]="true"
      [hasDeleteButton]="mode() === 'details' && detailReport()?.status_id !== 2 && (['monthly_rob_ship_interface', ['delete']] | permission)"
      [hasDiscardButton]="true"
      [onSave]="null"
      [hasSaveButton]="['monthly_rob_ship_interface', ['update']] | permission"
      [hasSubmitButton]="mode() === 'details' && detailReport()?.status_id !== 2 && (['monthly_rob_ship_interface', ['update']] | permission)"
      [saveButtonTitle]="
        (detailReport()?.status_id === 2
          ? 'button.submit'
          : detailReport()?.status_id === 3
            ? 'ship_interface.revert_status_to_saved'
            : 'ship_interface.save_draft'
        ) | transloco
      "
      [saveButtonClass]="detailReport()?.status_id === 3 ? 'bg-[#FAFAFA] text-[#FF0000]' : mode() === 'details' && 'bg-[#FAFAFA] text-primary'"
      [submitButtonClass]="'bg-primary'"
      [submitButtonTitle]="'ship_interface.save_review' | transloco"
      (delete)="onDelete()"
      (discard)="onDiscard()"
      (save)="onSave()"
      (submit)="onSubmit()" />
  </box>
}
